import * as AppConst from '../../store/modules/Constants';
import {
  Version,
  Platforms,
} from './types'

// AppConst.apiDomain might be undefined (not ready) when excuted in another JS file,
// hence only export endpoint path, apiDomain should be append later
export const jobsV1Url = '/jobs/v1';

export class JobStatus {
  public static NotStarted: string = 'not_started';
  public static readonly Uploading: string = 'uploading';
  public static readonly PipelineProcessing: string = 'pipeline_processing';
  public static readonly ResultCreation: string = 'result_creation';
  public static readonly Paused: string = 'paused';
  public static readonly Failed: string = 'failed';
  public static readonly Finished: string = 'finished';
}

export const JobStatuses: string[] = [
  JobStatus.NotStarted,
  JobStatus.Uploading,
  JobStatus.PipelineProcessing,
  JobStatus.ResultCreation,
  JobStatus.Paused,
  JobStatus.Failed,
  JobStatus.Finished,
];

function getTenantLibraryUploadingUrl(tenantId: any) {
  return `${AppConst.apiDomain}/tenants/v1/${tenantId}/library/v1/uploading/v1`;
}
export { getTenantLibraryUploadingUrl }

class VersionJson {
  public static readonly ID: number = 0;
  public static readonly Application: string = 'jigspace';
  public static readonly Platform: string = 'desktop';
  public static readonly Name: string = '';
  public static readonly Archived: boolean = false;
  public static readonly CreatedAt: string = '0001-01-01T00:00:00Z';
  public static readonly UpdatedAt: string = '0001-01-01T00:00:00Z';
  public static readonly SupportStart: string = '';
  public static readonly SupportEnd: string = '2040-01-01T23:59:59Z';
  public static readonly ExpiryReminderStartOffsetHRS: number = 168;
  public static readonly UpgradeCheckFrequencyHRS: number = 24;
  public static readonly UpgradeReminderMessage: string = 'This version of JigSpace will expire soon and will no longer be supported. You should update as soon as possible.';
  public static readonly Version: string = '';
  public static readonly Build: number = -1;
  public static readonly downloadFileUri: string = '';
}

export const VersionEntry: Version = {
  Application: VersionJson.Application,
  Name: VersionJson.Name,
  Platform: VersionJson.Platform,
  Archived: VersionJson.Archived,
  SupportStart: VersionJson.SupportStart,
  SupportEnd: VersionJson.SupportEnd,
  ExpiryReminderStartOffsetHRS: VersionJson.ExpiryReminderStartOffsetHRS,
  UpgradeCheckFrequencyHRS: VersionJson.UpgradeCheckFrequencyHRS,
  UpgradeReminderMessage: VersionJson.UpgradeReminderMessage,
  Version: VersionJson.Version,
};

class PlatformsJson {
  public static readonly desktop: string = 'Desktop';
  public static readonly ios: string = 'iOS';
}

export const PlatformsOptions: Platforms = {
  desktop: PlatformsJson.desktop,
  ios: PlatformsJson.ios,
};
export const DefaultPlatform: string = 'desktop';

export const DefaultApplication: string = 'jigspace';
export const ApplicationItems: Array<string> = [DefaultApplication];

